import mod from "-!./iconCloseSvg.js?vue&type=script&lang=js&"; export default mod; export * from "-!./iconCloseSvg.js?vue&type=script&lang=js&"